import React, { useState, useEffect } from "react";
import styles from "../styles/Prefs.module.css";
import AdminPasswordForm from "./AdminPasswordForm";

import { getApiUrl } from "../utils/config";
const API_URL = getApiUrl();

const Prefs2 = () => {
    const [isPasswordVerified, setIsPasswordVerified] = useState(false);
    
    // НОВОЕ: состояние для тестового автоначисления
    const [testCashbackLoading, setTestCashbackLoading] = useState(false);
    const [testCashbackResult, setTestCashbackResult] = useState(null);

    // Состояние для самовалидации GIS
    const [gisValidationLoading, setGisValidationLoading] = useState(false);
    const [gisValidationResult, setGisValidationResult] = useState(null);


    // Состояние для фриспинов
    const [freespinCampaigns, setFreespinCampaigns] = useState([]);
    const [freespinUserId, setFreespinUserId] = useState('');
    const [freespinLoading, setFreespinLoading] = useState(false);
    const [syncCleanupResult, setSyncCleanupResult] = useState(null);

    // Состояние для бэкапов
    const [backups, setBackups] = useState([]);
    const [backupLoading, setBackupLoading] = useState(false);
    const [backupResult, setBackupResult] = useState(null);
    const [backupFolder, setBackupFolder] = useState('');
    
    // Состояние для игр
    const [gamesStats, setGamesStats] = useState(null);
    const [gamesList, setGamesList] = useState([]);
    const [gamesLoading, setGamesLoading] = useState(false);
    const [gamesPage, setGamesPage] = useState(1);
    const [gamesSearch, setGamesSearch] = useState('');
    const [gamesProviderFilter, setGamesProviderFilter] = useState('');
    const [gamesTypeFilter, setGamesTypeFilter] = useState('');
    const [gamesTypesAvailable, setGamesTypesAvailable] = useState([]);
    const [gamesPagination, setGamesPagination] = useState(null);
    
    // Состояние для лимитов мерчанта
    const [merchantLimits, setMerchantLimits] = useState([]);
    const [merchantLimitsLoading, setMerchantLimitsLoading] = useState(false);
    
    // Состояние для статистики запусков игр
    const [launchStats, setLaunchStats] = useState(null);
    const [launchStatsLoading, setLaunchStatsLoading] = useState(false);
    const [launchStatsPeriod, setLaunchStatsPeriod] = useState('30');
    
    // Состояние для управления играми
    const [gamesManagementLoading, setGamesManagementLoading] = useState(false);
    const [gamesManagementResult, setGamesManagementResult] = useState(null);
    const [clearTablePassword, setClearTablePassword] = useState('');
    
    // Состояние для спарсенных изображений
    const [parsedImagesList, setParsedImagesList] = useState([]);
    const [parsedImagesLoading, setParsedImagesLoading] = useState(false);
    const [parsedImagesPage, setParsedImagesPage] = useState(1);
    const [parsedImagesSearch, setParsedImagesSearch] = useState('');
    const [parsedImagesStatus, setParsedImagesStatus] = useState('');
    const [parsedImagesPagination, setParsedImagesPagination] = useState(null);
    
    // Состояние для парсинга
    const [parsingLoading, setParsingLoading] = useState(false);
    const [parsingResult, setParsingResult] = useState(null);
    const [parsingStatus, setParsingStatus] = useState(null);
    

    useEffect(() => {
        if (isPasswordVerified) {
            fetchBackups();
            fetchGamesStats();
            fetchMerchantLimits();
            fetchLaunchStats();
        }
    }, [isPasswordVerified, launchStatsPeriod]);

    useEffect(() => {
        if (isPasswordVerified) {
            fetchGamesList();
        }
    }, [gamesPage, gamesSearch, gamesProviderFilter, gamesTypeFilter, isPasswordVerified]);

    useEffect(() => {
        if (isPasswordVerified) {
            fetchParsedImagesList();
        }
    }, [parsedImagesPage, parsedImagesSearch, parsedImagesStatus, isPasswordVerified]);

    // НОВАЯ функция: тестовое автоначисление кешбека
    const handleTestAutoCashback = async () => {
        if (!window.confirm("Запустить тестовое автоначисление кешбека для всех пользователей?")) return;

        setTestCashbackLoading(true);
        setTestCashbackResult(null);

        try {
            const res = await fetch(`${API_URL}/api/test-auto-cashback`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" }
            });
            const data = await res.json();

            if (data.success) {
                setTestCashbackResult({
                    success: true,
                    processedUsers: data.result.processedUsers,
                    totalCashback: data.result.totalCashback,
                    message: data.message
                });
            } else {
                setTestCashbackResult({
                    success: false,
                    message: data.message || 'Ошибка при выполнении автоначисления'
                });
            }
        } catch (error) {
            setTestCashbackResult({
                success: false,
                message: 'Ошибка соединения с сервером'
            });
        } finally {
            setTestCashbackLoading(false);
        }
    };

    // Функция для запуска самовалидации GIS
    const handleGisValidation = async () => {
        if (!window.confirm("Запустить самовалидацию интегратора GIS? Это проверит корректность реализации интеграции с игровым агрегатором.")) return;

        setGisValidationLoading(true);
        setGisValidationResult(null);

        try {
            const res = await fetch(`${API_URL}/api/admin/gis/self-validate`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" }
            });
            const data = await res.json();

            if (data.success) {
                setGisValidationResult({
                    success: true,
                    validationPassed: data.validation_result.success,
                    log: data.validation_result.log || [],
                    message: `Валидация ${data.validation_result.success ? 'успешно пройдена' : 'провалена'}`
                });
            } else {
                setGisValidationResult({
                    success: false,
                    message: data.message || 'Ошибка при выполнении валидации',
                    error: data.error
                });
            }
        } catch (error) {
            setGisValidationResult({
                success: false,
                message: 'Ошибка соединения с сервером',
                error: error.message
            });
        } finally {
            setGisValidationLoading(false);
        }
    };


    // Функции для работы с фриспинами
    const fetchFreespinCampaigns = async (userId = null) => {
        setFreespinLoading(true);
        try {
            const params = userId ? `?user_id=${userId}` : '';
            const res = await fetch(`${API_URL}/api/admin/freespins/campaigns${params}`, {
                credentials: "include"
            });
            const data = await res.json();
            if (data.success) {
                setFreespinCampaigns(data.campaigns);
            } else {
                alert(data.message);
                setFreespinCampaigns([]);
            }
        } catch (error) {
            console.error("Ошибка загрузки кампаний фриспинов:", error);
            alert("Ошибка при загрузке кампаний фриспинов");
            setFreespinCampaigns([]);
        } finally {
            setFreespinLoading(false);
        }
    };

    const handleCancelAllFreespins = async () => {
        if (!freespinUserId) {
            alert("Введите ID пользователя");
            return;
        }

        if (!window.confirm(`Отменить ВСЕ активные кампании фриспинов для пользователя ${freespinUserId}?`)) {
            return;
        }

        setFreespinLoading(true);
        try {
            const res = await fetch(`${API_URL}/api/admin/freespins/cancel-all/${freespinUserId}`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" }
            });
            const data = await res.json();

            if (data.success) {
                alert(`Успешно отменено кампаний: ${data.cancelled_count}`);
                // Обновляем список если смотрим кампании этого пользователя
                fetchFreespinCampaigns(freespinUserId);
            } else {
                alert(data.message);
            }
        } catch (error) {
            console.error("Ошибка отмены кампаний:", error);
            alert("Ошибка при отмене кампаний фриспинов");
        } finally {
            setFreespinLoading(false);
        }
    };

    const handleSyncCleanupFreespins = async () => {
        if (!freespinUserId) {
            alert("Введите ID пользователя");
            return;
        }

        if (!window.confirm(`Синхронизировать и очистить ВСЕ кампании фриспинов в GIS для пользователя ${freespinUserId}? Это отменит все зависшие кампании.`)) {
            return;
        }

        setFreespinLoading(true);
        setSyncCleanupResult(null);
        try {
            const res = await fetch(`${API_URL}/api/admin/freespins/sync-cleanup`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ user_id: freespinUserId })
            });
            const data = await res.json();

            if (data.success) {
                setSyncCleanupResult(data.results);
                alert(`Синхронизация завершена:\n` +
                    `Проверено: ${data.results.checked}\n` +
                    `Отменено в GIS: ${data.results.cancelled_in_gis}\n` +
                    `Не найдено в GIS: ${data.results.not_found_in_gis}\n` +
                    `Ошибок: ${data.results.errors.length}`
                );
                // Обновляем список
                fetchFreespinCampaigns(freespinUserId);
            } else {
                alert(data.message);
            }
        } catch (error) {
            console.error("Ошибка синхронизации:", error);
            alert("Ошибка при синхронизации кампаний");
        } finally {
            setFreespinLoading(false);
        }
    };

    // Функции для работы с бэкапами
    const fetchBackups = async () => {
        try {
            const res = await fetch(`${API_URL}/api/admin/backup/list`, { credentials: "include" });
            const data = await res.json();
            if (data.success) {
                setBackups(data.data.backups);
                setBackupFolder(data.data.backupFolder || '');
            }
        } catch (error) {
            console.error("Ошибка загрузки списка бэкапов:", error);
        }
    };

    const handleCreateBackup = async () => {
        if (!window.confirm("Создать бэкап базы данных и файлов? Это может занять несколько минут.")) return;

        setBackupLoading(true);
        setBackupResult(null);

        try {
            const res = await fetch(`${API_URL}/api/admin/backup/create`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" }
            });
            const data = await res.json();

            if (data.success) {
                setBackupResult({
                    success: true,
                    message: data.message,
                    dbFileName: data.data.dbFileName,
                    verificationsFileName: data.data.verificationsFileName,
                    dbSize: data.data.dbSize,
                    verificationsSize: data.data.verificationsSize,
                    totalSize: data.data.totalSize,
                    timestamp: data.data.timestamp
                });
                fetchBackups(); // Обновляем список
            } else {
                setBackupResult({
                    success: false,
                    message: data.message || 'Ошибка при создании бэкапа'
                });
            }
        } catch (error) {
            setBackupResult({
                success: false,
                message: 'Ошибка соединения с сервером'
            });
        } finally {
            setBackupLoading(false);
        }
    };

    // Функции для работы с играми
    const fetchGamesStats = async () => {
        try {
            const res = await fetch(`${API_URL}/api/admin/games/stats`, { credentials: "include" });
            const data = await res.json();
            if (data.success) {
                setGamesStats(data.data);
            }
        } catch (error) {
            console.error("Ошибка загрузки статистики игр:", error);
        }
    };

    const fetchGamesList = async () => {
        setGamesLoading(true);
        try {
            const params = new URLSearchParams({
                page: gamesPage,
                limit: 15,
                search: gamesSearch,
                provider: gamesProviderFilter,
                type: gamesTypeFilter
            });

            const res = await fetch(`${API_URL}/api/admin/games/list?${params}`, { credentials: "include" });
            const data = await res.json();
            
            if (data.success) {
                setGamesList(data.data.games);
                setGamesPagination(data.data.pagination);
                if (data.data.filters?.availableTypes) {
                    setGamesTypesAvailable(data.data.filters.availableTypes);
                }
            } else {
                setGamesList([]);
                setGamesPagination(null);
            }
        } catch (error) {
            console.error("Ошибка загрузки списка игр:", error);
            setGamesList([]);
            setGamesPagination(null);
        } finally {
            setGamesLoading(false);
        }
    };

    const handleGamesSearch = (searchValue) => {
        setGamesSearch(searchValue);
        setGamesPage(1); // Сбрасываем на первую страницу при поиске
    };

    const handleGamesProviderFilter = (providerValue) => {
        setGamesProviderFilter(providerValue);
        setGamesPage(1); // Сбрасываем на первую страницу при фильтрации
    };

    const handleGamesTypeFilter = (typeValue) => {
        setGamesTypeFilter(typeValue);
        setGamesPage(1); // Сбрасываем на первую страницу при фильтрации
    };

    // Функция для загрузки лимитов мерчанта
    const fetchMerchantLimits = async () => {
        setMerchantLimitsLoading(true);
        try {
            const res = await fetch(`${API_URL}/api/admin/gis/merchant-limits`, { 
                credentials: "include" 
            });
            const data = await res.json();
            
            if (data.success) {
                setMerchantLimits(data.data || []);
            } else {
                console.error("Ошибка загрузки лимитов мерчанта:", data.message);
                setMerchantLimits([]);
            }
        } catch (error) {
            console.error("Ошибка загрузки лимитов мерчанта:", error);
            setMerchantLimits([]);
        } finally {
            setMerchantLimitsLoading(false);
        }
    };

    // Функция для переключения провайдера
    const toggleProvider = async (provider, enabled) => {
        try {
            const res = await fetch(`${API_URL}/api/admin/games/toggle-provider`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ provider, enabled })
            });
            const data = await res.json();
            
            if (data.success) {
                alert(data.message);
                fetchGamesStats(); // Обновляем статистику
            } else {
                alert(data.message);
            }
        } catch (error) {
            alert("Ошибка при переключении провайдера");
        }
    };

    // Функция для загрузки статистики запусков
    const fetchLaunchStats = async () => {
        setLaunchStatsLoading(true);
        try {
            const res = await fetch(`${API_URL}/api/admin/games/launch-stats?period=${launchStatsPeriod}&limit=20`, {
                credentials: "include"
            });
            const data = await res.json();
            
            if (data.success) {
                setLaunchStats(data.data);
            } else {
                console.error("Ошибка загрузки статистики запусков:", data.message);
                setLaunchStats(null);
            }
        } catch (error) {
            console.error("Ошибка загрузки статистики запусков:", error);
            setLaunchStats(null);
        } finally {
            setLaunchStatsLoading(false);
        }
    };

    // Функции для управления играми
    const handleClearGamesTable = async () => {
        if (!clearTablePassword) {
            alert("Введите пароль для подтверждения");
            return;
        }

        if (!window.confirm("Вы уверены? Это действие удалит ВСЕ игры из таблицы и все скаченные изображения GIS!")) {
            return;
        }

        setGamesManagementLoading(true);
        setGamesManagementResult(null);

        try {
            const res = await fetch(`${API_URL}/api/admin/games/clear-table`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ password: clearTablePassword })
            });
            const data = await res.json();

            setGamesManagementResult(data);
            if (data.success) {
                setClearTablePassword('');
                fetchGamesStats(); // Обновляем статистику
            }
        } catch (error) {
            setGamesManagementResult({
                success: false,
                message: 'Ошибка соединения с сервером'
            });
        } finally {
            setGamesManagementLoading(false);
        }
    };

    const handleFetchGamesFromGIS = async () => {
        if (!window.confirm("Запросить все игры у GIS API? Это может занять несколько минут.")) {
            return;
        }

        setGamesManagementLoading(true);
        setGamesManagementResult(null);

        try {
            const res = await fetch(`${API_URL}/api/admin/games/fetch-from-gis`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" }
            });
            const data = await res.json();

            setGamesManagementResult(data);
            if (data.success) {
                fetchGamesStats(); // Обновляем статистику
            }
        } catch (error) {
            setGamesManagementResult({
                success: false,
                message: 'Ошибка соединения с сервером'
            });
        } finally {
            setGamesManagementLoading(false);
        }
    };

    const handleDownloadGISImages = async () => {
        if (!window.confirm("Скачать изображения GIS для всех игр? Это может занять много времени.")) {
            return;
        }

        setGamesManagementLoading(true);
        setGamesManagementResult(null);

        try {
            const res = await fetch(`${API_URL}/api/admin/games/download-gis-images`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" }
            });
            const data = await res.json();

            setGamesManagementResult(data);
            if (data.success) {
                fetchGamesStats(); // Обновляем статистику
            }
        } catch (error) {
            setGamesManagementResult({
                success: false,
                message: 'Ошибка соединения с сервером'
            });
        } finally {
            setGamesManagementLoading(false);
        }
    };

    const handleSyncParsedImages = async () => {
        if (!window.confirm("Синхронизировать парсенные изображения с таблицей игр?")) {
            return;
        }

        setGamesManagementLoading(true);
        setGamesManagementResult(null);

        try {
            const res = await fetch(`${API_URL}/api/admin/games/sync-parsed-images`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" }
            });
            const data = await res.json();

            setGamesManagementResult(data);
            if (data.success) {
                fetchGamesStats(); // Обновляем статистику
                fetchParsedImagesList(); // Обновляем список спарсенных изображений
            }
        } catch (error) {
            setGamesManagementResult({
                success: false,
                message: 'Ошибка соединения с сервером'
            });
        } finally {
            setGamesManagementLoading(false);
        }
    };

    // Функция для загрузки списка спарсенных изображений
    const fetchParsedImagesList = async () => {
        setParsedImagesLoading(true);
        try {
            const params = new URLSearchParams({
                page: parsedImagesPage,
                limit: 15,
                search: parsedImagesSearch,
                status: parsedImagesStatus
            });

            const res = await fetch(`${API_URL}/api/admin/games/parsed-images-list?${params}`, { 
                credentials: "include" 
            });
            const data = await res.json();
            
            if (data.success) {
                setParsedImagesList(data.data.images);
                setParsedImagesPagination(data.data.pagination);
            } else {
                setParsedImagesList([]);
                setParsedImagesPagination(null);
            }
        } catch (error) {
            console.error("Ошибка загрузки списка спарсенных изображений:", error);
            setParsedImagesList([]);
            setParsedImagesPagination(null);
        } finally {
            setParsedImagesLoading(false);
        }
    };

    const handleParsedImagesSearch = (searchValue) => {
        setParsedImagesSearch(searchValue);
        setParsedImagesPage(1);
    };

    const handleParsedImagesStatusFilter = (statusValue) => {
        setParsedImagesStatus(statusValue);
        setParsedImagesPage(1);
    };

    // Функции для парсинга
    const handleStartParsing = async () => {
        if (!window.confirm("Запустить парсинг изображений с enjoyer.vodka?")) {
            return;
        }

        setParsingLoading(true);
        setParsingResult(null);

        try {
            const res = await fetch(`${API_URL}/api/admin/parser/start`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" }
            });
            const data = await res.json();

            setParsingResult(data);
            if (data.success) {
                // Обновляем статистику игр
                fetchGamesStats();
                // Начинаем опрос статуса
                startStatusPolling();
            }
        } catch (error) {
            setParsingResult({
                success: false,
                message: 'Ошибка соединения с сервером'
            });
        } finally {
            setParsingLoading(false);
        }
    };

    const fetchParsingStatus = async () => {
        try {
            const res = await fetch(`${API_URL}/api/admin/parser/status`, {
                method: "GET",
                credentials: "include"
            });
            const data = await res.json();

            if (data.success) {
                setParsingStatus(data.data);
            }
        } catch (error) {
            console.error('Ошибка получения статуса парсинга:', error);
        }
    };

    const startStatusPolling = () => {
        const interval = setInterval(() => {
            fetchParsingStatus();
        }, 2000); // Опрашиваем каждые 2 секунды

        // Останавливаем опрос через 5 минут
        setTimeout(() => {
            clearInterval(interval);
        }, 300000);
    };

    const handleDownloadParsedImages = async () => {
        if (!window.confirm("Скачать парсенные изображения на сервер?")) {
            return;
        }

        setParsingLoading(true);
        setParsingResult(null);

        try {
            const res = await fetch(`${API_URL}/api/admin/parser/download`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" }
            });
            const data = await res.json();

            setParsingResult(data);
            if (data.success) {
                // Обновляем статистику игр
                fetchGamesStats();
            }
        } catch (error) {
            setParsingResult({
                success: false,
                message: 'Ошибка соединения с сервером'
            });
        } finally {
            setParsingLoading(false);
        }
    };

    const handleDeleteDownloadedImages = async () => {
        if (!window.confirm("Удалить все скачанные изображения? Это действие нельзя отменить!")) {
            return;
        }

        setParsingLoading(true);
        setParsingResult(null);

        try {
            const res = await fetch(`${API_URL}/api/admin/parser/delete-downloaded`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" }
            });
            const data = await res.json();

            setParsingResult(data);
            if (data.success) {
                // Обновляем статистику игр
                fetchGamesStats();
            }
        } catch (error) {
            setParsingResult({
                success: false,
                message: 'Ошибка соединения с сервером'
            });
        } finally {
            setParsingLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '—';
        return new Date(dateString).toLocaleString('ru-RU');
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'active': return '#28bc10';
            case 'Played all': return '#b6b6c6';
            case 'cancelled': return '#ff4757';
            default: return '#333';
        }
    };

    const getSyncStatusInfo = (campaign) => {
        if (!campaign.is_synced) {
            return {
                icon: '❌',
                color: '#ff4757',
                title: 'Ошибка синхронизации',
                details: campaign.gis_sync_error || 'Не удалось получить данные из GIS'
            };
        }

        if (!campaign.data_match) {
            let mismatches = [];
            if (campaign.detailed_comparison?.comparison) {
                const comp = campaign.detailed_comparison.comparison;
                const local = campaign.detailed_comparison.local;
                const gis = campaign.detailed_comparison.gis;

                if (!comp.quantity_match) {
                    mismatches.push(`Общее кол-во: ${local.quantity} ≠ ${gis.quantity}`);
                }
                if (!comp.quantity_left_match) {
                    mismatches.push(`Осталось: ${local.quantity_left} ≠ ${gis.quantity_left}`);
                }
                if (!comp.used_match) {
                    mismatches.push(`Использовано: ${local.quantity_used} ≠ ${gis.quantity_used}`);
                }
                if (!comp.status_match) {
                    const gisDisplayStatus = gis.is_canceled ? `${gis.status} (ОТМЕНЕНА)` : gis.status;
                    mismatches.push(`Статус: ${local.status} ≠ ${gisDisplayStatus}`);
                }
                if (!comp.bet_amount_match) {
                    mismatches.push(`Ставка: ${local.bet_amount} ≠ ${gis.bet_amount}`);
                }
                if (!comp.currency_match) {
                    mismatches.push(`Валюта: ${local.currency} ≠ ${gis.currency}`);
                }
            }

            return {
                icon: '⚠️',
                color: '#ffb300',
                title: 'Данные не совпадают',
                details: mismatches.length > 0 ? mismatches.join('\n') : 'Обнаружены несоответствия в данных'
            };
        }

        return {
            icon: '✅',
            color: '#28bc10',
            title: 'Синхронизировано',
            details: 'Все данные совпадают с GIS'
        };
    };

    if (!isPasswordVerified) {
        return <AdminPasswordForm onPasswordCorrect={() => setIsPasswordVerified(true)} />;
    }

    return (
        <div className={styles["prefs-admin-container"]}>
            <h1>Админ-панель - Часть 2</h1>

            <div className={styles["prefs-section"]}>
                <h2>📊 Статистика игр</h2>
                
                {/* Кнопки управления играми */}
                <div className={styles["mb-6"]}>
                    <h4>🛠️ Управление играми:</h4>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '15px', marginBottom: '20px' }}>
                        
                        {/* Очистка таблицы */}
                        <div style={{ padding: '15px', border: '2px solid #ff4757', borderRadius: '8px', backgroundColor: '#fff5f5' }}>
                            <h5 style={{ color: '#ff4757', margin: '0 0 10px 0' }}>🗑️ Очистить таблицу</h5>
                            <input
                                type="password"
                                placeholder="Пароль админки"
                                value={clearTablePassword}
                                onChange={(e) => setClearTablePassword(e.target.value)}
                                style={{ width: '100%', padding: '8px', marginBottom: '10px', borderRadius: '4px', border: '1px solid rgba(148, 163, 184, 0.2)', backgroundColor: 'rgba(30, 41, 59, 0.8)', color: '#e2e8f0' }}
                            />
                            <button
                                onClick={handleClearGamesTable}
                                disabled={gamesManagementLoading || !clearTablePassword}
                                style={{ 
                                    width: '100%', 
                                    padding: '10px', 
                                    backgroundColor: '#ff4757', 
                                    color: 'white', 
                                    border: 'none', 
                                    borderRadius: '4px',
                                    opacity: (!clearTablePassword || gamesManagementLoading) ? 0.6 : 1,
                                    cursor: (!clearTablePassword || gamesManagementLoading) ? 'not-allowed' : 'pointer'
                                }}
                            >
                                {gamesManagementLoading ? '⏳ Очистка...' : '🗑️ Очистить всё'}
                            </button>
                        </div>

                        {/* Запрос игр у GIS */}
                        <div style={{ padding: '15px', border: '2px solid #4891ff', borderRadius: '8px', backgroundColor: 'rgba(30, 41, 59, 0.6)' }}>
                            <h5 style={{ color: '#60a5fa', margin: '0 0 10px 0' }}>📥 Запросить игры у GIS</h5>
                            <p style={{ fontSize: '12px', color: '#94a3b8', margin: '0 0 10px 0' }}>
                                Загружает все игры из GIS API в таблицу
                            </p>
                            <button
                                onClick={handleFetchGamesFromGIS}
                                disabled={gamesManagementLoading}
                                style={{ 
                                    width: '100%', 
                                    padding: '10px', 
                                    backgroundColor: '#4891ff', 
                                    color: 'white', 
                                    border: 'none', 
                                    borderRadius: '4px',
                                    opacity: gamesManagementLoading ? 0.6 : 1,
                                    cursor: gamesManagementLoading ? 'not-allowed' : 'pointer'
                                }}
                            >
                                {gamesManagementLoading ? '⏳ Загрузка...' : '📥 Загрузить игры'}
                            </button>
                        </div>

                        {/* Скачивание изображений GIS */}
                        <div style={{ padding: '15px', border: '2px solid #28bc10', borderRadius: '8px', backgroundColor: '#f0fff0' }}>
                            <h5 style={{ color: '#28bc10', margin: '0 0 10px 0' }}>📸 Скачать изображения GIS</h5>
                            <p style={{ fontSize: '12px', color: '#666', margin: '0 0 10px 0' }}>
                                Скачивает изображения по ссылкам из таблицы
                            </p>
                            <button
                                onClick={handleDownloadGISImages}
                                disabled={gamesManagementLoading}
                                style={{ 
                                    width: '100%', 
                                    padding: '10px', 
                                    backgroundColor: '#28bc10', 
                                    color: 'white', 
                                    border: 'none', 
                                    borderRadius: '4px',
                                    opacity: gamesManagementLoading ? 0.6 : 1,
                                    cursor: gamesManagementLoading ? 'not-allowed' : 'pointer'
                                }}
                            >
                                {gamesManagementLoading ? '⏳ Скачивание...' : '📸 Скачать изображения'}
                            </button>
                        </div>

                        {/* Синхронизация парсенных изображений */}
                        <div style={{ padding: '15px', border: '2px solid #ffb300', borderRadius: '8px', backgroundColor: '#fffbf0' }}>
                            <h5 style={{ color: '#ffb300', margin: '0 0 10px 0' }}>🔄 Поставить парсенные изображения</h5>
                            <p style={{ fontSize: '12px', color: '#666', margin: '0 0 10px 0' }}>
                                Синхронизирует парсенные изображения с таблицей игр
                            </p>
                            <button
                                onClick={handleSyncParsedImages}
                                disabled={gamesManagementLoading}
                                style={{ 
                                    width: '100%', 
                                    padding: '10px', 
                                    backgroundColor: '#ffb300', 
                                    color: 'white', 
                                    border: 'none', 
                                    borderRadius: '4px',
                                    opacity: gamesManagementLoading ? 0.6 : 1,
                                    cursor: gamesManagementLoading ? 'not-allowed' : 'pointer'
                                }}
                            >
                                {gamesManagementLoading ? '⏳ Синхронизация...' : '🔄 Синхронизировать'}
                            </button>
                        </div>
                    </div>

                    {/* Секция парсинга */}
                    <div style={{ marginTop: '30px', padding: '20px', border: '2px solid #28bc10', borderRadius: '8px', backgroundColor: '#f0fff4' }}>
                        <h4 style={{ color: '#28bc10', margin: '0 0 15px 0' }}>🕷️ Парсинг изображений</h4>
                        <p style={{ fontSize: '14px', color: '#666', margin: '0 0 15px 0' }}>
                            Парсинг изображений с enjoyer.vodka и сохранение в базу данных
                        </p>
                        
                        <div style={{ display: 'flex', gap: '15px', alignItems: 'center', flexWrap: 'wrap' }}>
                            <button
                                onClick={handleStartParsing}
                                disabled={parsingLoading}
                                style={{ 
                                    padding: '12px 20px', 
                                    backgroundColor: '#28bc10', 
                                    color: 'white', 
                                    border: 'none', 
                                    borderRadius: '6px',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    opacity: parsingLoading ? 0.6 : 1,
                                    cursor: parsingLoading ? 'not-allowed' : 'pointer'
                                }}
                            >
                                {parsingLoading ? '⏳ Парсинг...' : '🕷️ Запустить парсинг'}
                            </button>

                            <button
                                onClick={fetchParsingStatus}
                                disabled={parsingLoading}
                                style={{ 
                                    padding: '10px 15px', 
                                    backgroundColor: '#4891ff', 
                                    color: 'white', 
                                    border: 'none', 
                                    borderRadius: '6px',
                                    cursor: 'pointer'
                                }}
                            >
                                📊 Статус
                            </button>

                            <button
                                onClick={handleDownloadParsedImages}
                                disabled={parsingLoading}
                                style={{ 
                                    padding: '10px 15px', 
                                    backgroundColor: '#ff6b35', 
                                    color: 'white', 
                                    border: 'none', 
                                    borderRadius: '6px',
                                    cursor: 'pointer'
                                }}
                            >
                                📥 Скачать изображения
                            </button>

                            <button
                                onClick={handleDeleteDownloadedImages}
                                disabled={parsingLoading}
                                style={{ 
                                    padding: '10px 15px', 
                                    backgroundColor: '#dc3545', 
                                    color: 'white', 
                                    border: 'none', 
                                    borderRadius: '6px',
                                    cursor: 'pointer'
                                }}
                            >
                                🗑️ Удалить скачанные
                            </button>
                        </div>

                        {/* Статус парсинга */}
                        {parsingStatus && (
                            <div style={{ 
                                marginTop: '15px', 
                                padding: '10px', 
                                backgroundColor: '#e8f4fd', 
                                borderRadius: '6px',
                                border: '1px solid #b3d9ff'
                            }}>
                                <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>📊 Статус парсинга:</div>
                                <div>🔄 Запущен: {parsingStatus.isRunning ? 'Да' : 'Нет'}</div>
                                <div>🎮 Игр найдено: {parsingStatus.totalGames || 0}</div>
                                {parsingStatus.games && parsingStatus.games.length > 0 && (
                                    <div style={{ marginTop: '10px' }}>
                                        <div style={{ fontSize: '12px', color: '#666' }}>Последние игры:</div>
                                        {parsingStatus.games.slice(0, 3).map((game, index) => (
                                            <div key={index} style={{ fontSize: '12px', color: '#333' }}>
                                                • {game.name} ({game.provider || 'N/A'})
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}

                        {/* Результат парсинга */}
                        {parsingResult && (
                            <div style={{ 
                                marginTop: '15px',
                                padding: '15px', 
                                borderRadius: '8px',
                                backgroundColor: parsingResult.success ? '#d4edda' : '#f8d7da',
                                border: `1px solid ${parsingResult.success ? '#c3e6cb' : '#f5c6cb'}`,
                                color: parsingResult.success ? '#155724' : '#721c24'
                            }}>
                                <strong>{parsingResult.success ? '✅ Парсинг запущен:' : '❌ Ошибка:'}</strong> {parsingResult.message}
                                {parsingResult.data && (
                                    <div style={{ marginTop: '10px', fontSize: '14px' }}>
                                        <div>🕷️ Запущен: {new Date(parsingResult.data.startedAt).toLocaleString()}</div>
                                        {parsingResult.data.parserResult && (
                                            <div>📊 Результат парсера: {JSON.stringify(parsingResult.data.parserResult)}</div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Результат операции */}
                    {gamesManagementResult && (
                        <div style={{ 
                            padding: '15px', 
                            borderRadius: '8px',
                            backgroundColor: gamesManagementResult.success ? '#d4edda' : '#f8d7da',
                            border: `1px solid ${gamesManagementResult.success ? '#c3e6cb' : '#f5c6cb'}`,
                            color: gamesManagementResult.success ? '#155724' : '#721c24',
                            marginBottom: '20px'
                        }}>
                            <strong>{gamesManagementResult.success ? '✅ Успешно:' : '❌ Ошибка:'}</strong> {gamesManagementResult.message}
                            {gamesManagementResult.data && (
                                <div style={{ marginTop: '10px', fontSize: '14px' }}>
                                    {gamesManagementResult.data.deletedGames && (
                                        <div>🗑️ Удалено игр: {gamesManagementResult.data.deletedGames}</div>
                                    )}
                                    {gamesManagementResult.data.deletedParsedRecords && (
                                        <div>🕷️ Удалено парсенных записей: {gamesManagementResult.data.deletedParsedRecords}</div>
                                    )}
                                    {gamesManagementResult.data.deletedImages && (
                                        <div>🖼️ Удалено изображений игр: {gamesManagementResult.data.deletedImages}</div>
                                    )}
                                    {gamesManagementResult.data.deletedParsedImages && (
                                        <div>📸 Удалено парсенных изображений: {gamesManagementResult.data.deletedParsedImages}</div>
                                    )}
                                    {gamesManagementResult.data.totalFetched && (
                                        <div>📥 Получено игр: {gamesManagementResult.data.totalFetched}</div>
                                    )}
                                    {gamesManagementResult.data.savedCount && (
                                        <div>💾 Сохранено: {gamesManagementResult.data.savedCount}</div>
                                    )}
                                    {gamesManagementResult.data.downloadedCount && (
                                        <div>📸 Скачано изображений: {gamesManagementResult.data.downloadedCount}</div>
                                    )}
                                    {gamesManagementResult.data.syncedCount !== undefined && (
                                        <div>🔄 Синхронизировано: {gamesManagementResult.data.syncedCount}</div>
                                    )}
                                    {gamesManagementResult.data.notFoundCount !== undefined && (
                                        <div>⚠️ Не найдено: {gamesManagementResult.data.notFoundCount}</div>
                                    )}
                                    {gamesManagementResult.data.errorCount !== undefined && (
                                        <div>❌ Ошибок: {gamesManagementResult.data.errorCount}</div>
                                    )}
                                    {gamesManagementResult.data.totalSizeMB && (
                                        <div>💾 Размер: {gamesManagementResult.data.totalSizeMB} MB</div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>
                
                {gamesStats && (
                    <div>
                        <div className={styles["stats-grid"]}>
                            <div className={`${styles["stat-card"]} ${styles["bg-blue-100"]}`}>
                                <div className={`${styles["stat-number"]} ${styles["text-blue-600"]}`}>
                                    {gamesStats.stats.totalGames}
                                </div>
                                <div className={styles["stat-label"]}>
                                    Всего игр в базе
                                </div>
                            </div>

                            <div className={`${styles["stat-card"]} ${styles["bg-green-100"]}`}>
                                <div className={`${styles["stat-number"]} ${styles["text-green-600"]}`}>
                                    {gamesStats.stats.totalProviders}
                                </div>
                                <div className={styles["stat-label"]}>
                                    Провайдеров
                                </div>
                            </div>

                            <div className={`${styles["stat-card"]} ${styles["bg-yellow-100"]}`}>
                                <div className={`${styles["stat-number"]} ${styles["text-yellow-600"]}`}>
                                    {gamesStats.stats.gamesWithImages}
                                </div>
                                <div className={styles["stat-label"]}>
                                    С изображениями
                                </div>
                            </div>

                            <div className={`${styles["stat-card"]} ${styles["bg-purple-100"]}`}>
                                <div className={`${styles["stat-number"]} ${styles["text-purple-600"]}`}>
                                    {gamesStats.stats.gamesWithParsedImages}
                                </div>
                                <div className={styles["stat-label"]}>
                                    С парсенными изображениями
                                </div>
                            </div>

                            <div className={`${styles["stat-card"]} ${styles["bg-indigo-100"]}`}>
                                <div className={`${styles["stat-number"]} ${styles["text-indigo-600"]}`}>
                                    {gamesStats.stats.gamesWithGISImages}
                                </div>
                                <div className={styles["stat-label"]}>
                                    Со ссылками GIS
                            </div>
                        </div>

                            <div className={`${styles["stat-card"]} ${styles["bg-pink-100"]}`}>
                                <div className={`${styles["stat-number"]} ${styles["text-pink-600"]}`}>
                                    {gamesStats.stats.gamesWithDownloadedGISImages}
                                        </div>
                                <div className={styles["stat-label"]}>
                                    Скачано из GIS
                                        </div>
                                    </div>
                        </div>

                        <div className={styles["mb-6"]}>
                            <h4>🎮 Управление провайдерами:</h4>
                            <div className={styles["prefs-table-wrapper"]}>
                                <table className={styles["prefs-table"]}>
                                    <thead>
                                        <tr>
                                            <th>Провайдер</th>
                                            <th>Всего игр</th>
                                            <th>С изображениями</th>
                                            <th>Ссылки GIS</th>
                                            <th>Скачано GIS</th>
                                            <th>С парсенными</th>
                                            <th>Статус</th>
                                            <th>Действия</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {gamesStats.providersList.map((provider, index) => (
                                            <tr key={provider.provider}>
                                                <td>
                                                    <strong>{provider.provider}</strong>
                                                </td>
                                                <td>
                                                    <span className={`${styles["badge"]} ${styles["badge-info"]}`}>
                                                        {provider.total_games}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className={`${styles["badge"]} ${styles["badge-success"]}`}>
                                                        {provider.games_with_images}
                                                    </span>
                                                    <span className={`${styles["text-xs"]} ${styles["text-gray-400"]} ${styles["ml-1"]}`}>
                                                        ({((provider.games_with_images / provider.total_games) * 100).toFixed(1)}%)
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className={`${styles["badge"]} ${styles["badge-info"]}`}>
                                                        {provider.games_with_gis_images}
                                                    </span>
                                                    <span className={`${styles["text-xs"]} ${styles["text-gray-400"]} ${styles["ml-1"]}`}>
                                                        ({((provider.games_with_gis_images / provider.total_games) * 100).toFixed(1)}%)
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className={`${styles["badge"]} ${styles["badge-primary"]}`}>
                                                        {provider.games_with_downloaded_gis_images}
                                                    </span>
                                                    <span className={`${styles["text-xs"]} ${styles["text-gray-400"]} ${styles["ml-1"]}`}>
                                                        ({((provider.games_with_downloaded_gis_images / provider.total_games) * 100).toFixed(1)}%)
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className={`${styles["badge"]} ${styles["badge-warning"]}`}>
                                                        {provider.games_with_parsed_images}
                                                    </span>
                                                    <span className={`${styles["text-xs"]} ${styles["text-gray-400"]} ${styles["ml-1"]}`}>
                                                        ({((provider.games_with_parsed_images / provider.total_games) * 100).toFixed(1)}%)
                                                    </span>
                                                </td>
                                                <td>
                                                    <span style={{
                                                        color: provider.is_enabled ? '#28bc10' : '#ff4757',
                                                        fontWeight: 'bold'
                                                    }}>
                                                        {provider.is_enabled ? '✅ Включен' : '❌ Выключен'}
                                                    </span>
                                                </td>
                                                <td>
                                                    <button
                                                        onClick={() => toggleProvider(provider.provider, !provider.is_enabled)}
                                                        style={{
                                                            backgroundColor: provider.is_enabled ? '#ff4757' : '#28bc10',
                                                            color: 'white',
                                                            border: 'none',
                                                            padding: '4px 8px',
                                                            borderRadius: '3px',
                                                            fontSize: '12px',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        {provider.is_enabled ? '🚫 Выключить' : '✅ Включить'}
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div>
                            <h4>📥 Статистика парсенных изображений:</h4>
                            <div className={`${styles["flex"]} ${styles["gap-6"]} ${styles["flex-wrap"]}`}>
                                {Object.entries(gamesStats.parsedImagesStats).map(([status, count]) => (
                                    <div key={status} className={`${styles["badge"]} ${
                                        status === 'completed' ? styles["badge-success"] :
                                        status === 'failed' ? styles["badge-error"] : 
                                        styles["badge-warning"]
                                    }`}>
                                        <span className={styles["font-bold"]}>
                                            {status === 'completed' ? '✅ Успешно' :
                                             status === 'failed' ? '❌ Ошибка' :
                                             status === 'pending' ? '⏳ В очереди' : status}
                                        </span>
                                        <span className={`${styles["ml-1"]} ${styles["text-sm"]}`}>
                                            {count} изображений
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                <div className={styles["info-block"]}>
                    <strong>Информация:</strong><br />
                    • Статистика обновляется автоматически при загрузке страницы<br />
                    • Парсенные изображения загружаются с внешних источников<br />
                    • Данные кешируются для быстрого отображения<br />
                    • Выключенные провайдеры не отображаются на сайте и в коллекциях
                </div>
            </div>

            <div className={styles["prefs-section"]}>
                <h2>🖼️ Спарсенные изображения</h2>

                <div className={`${styles["flex"]} ${styles["gap-4"]} ${styles["mb-6"]} ${styles["flex-wrap"]} ${styles["items-center"]}`}>
                    <div className={styles["form-group"]}>
                        <label className={styles["form-label"]}>
                            🔍 Поиск по названию:
                        </label>
                        <input
                            type="text"
                            value={parsedImagesSearch}
                            onChange={(e) => handleParsedImagesSearch(e.target.value)}
                            placeholder="Введите название игры..."
                            className={`${styles["form-input"]} ${styles["w-full"]}`}
                        />
                    </div>

                    <div className={styles["form-group"]}>
                        <label className={styles["form-label"]}>
                            📂 Фильтр по статусу:
                        </label>
                        <select
                            value={parsedImagesStatus}
                            onChange={(e) => handleParsedImagesStatusFilter(e.target.value)}
                            className={`${styles["form-select"]}`}
                        >
                            <option value="">Все статусы</option>
                            <option value="downloaded">✅ Скачано</option>
                            <option value="pending">⏳ В очереди</option>
                            <option value="failed">❌ Ошибка</option>
                        </select>
                    </div>

                    <div className={styles["mt-6"]}>
                        <button
                            onClick={() => fetchParsedImagesList()}
                            disabled={parsedImagesLoading}
                            className={styles["btn-primary"]}
                        >
                            {parsedImagesLoading ? '⏳ Загрузка...' : '🔄 Обновить'}
                        </button>
                    </div>
                </div>

                {parsedImagesLoading ? (
                    <div className={`${styles["text-center"]} ${styles["p-10"]} ${styles["text-lg"]} ${styles["text-gray-400"]}`}>
                        ⏳ Загрузка спарсенных изображений...
                    </div>
                ) : (
                    <>
                        {parsedImagesPagination && (
                            <div className={`${styles["mb-4"]} ${styles["text-sm"]} ${styles["text-gray-400"]}`}>
                                Показано {parsedImagesList.length} из {parsedImagesPagination.total} изображений 
                                (страница {parsedImagesPagination.page} из {parsedImagesPagination.totalPages})
                            </div>
                        )}

                        <div className={styles["prefs-table-wrapper"]}>
                            <table className={styles["prefs-table"]}>
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Название игры</th>
                                        <th>Провайдер</th>
                                        <th>Изображение</th>
                                        <th>Оригинальная ссылка</th>
                                        <th>Статус</th>
                                        <th>Создано</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {parsedImagesList.map((image) => (
                                        <tr key={image.id}>
                                            <td className={`${styles["text-xs"]} ${styles["font-mono"]}`}>
                                                {image.id}
                                            </td>
                                            <td className={styles["font-bold"]}>
                                                {image.game_name}
                                            </td>
                                            <td>
                                                {image.provider ? (
                                                    <span style={{ 
                                                        backgroundColor: '#e3f2fd', 
                                                        padding: '4px 8px', 
                                                        borderRadius: '4px',
                                                        fontSize: '12px',
                                                        fontWeight: 'bold'
                                                    }}>
                                                        {image.provider}
                                                    </span>
                                                ) : (
                                                    <span style={{ color: '#999', fontSize: '12px' }}>—</span>
                                                )}
                                            </td>
                                            <td>
                                                {image.local_image_path ? (
                                                    <a 
                                                        href={`${API_URL}${image.local_image_path}`} 
                                                        target="_blank" 
                                                        rel="noopener noreferrer"
                                                        style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                                    >
                                                        <img
                                                            src={`${API_URL}${image.local_image_path}`}
                                                            alt={image.game_name}
                                                            style={{ width: '40px', height: '40px', borderRadius: '4px', objectFit: 'cover' }}
                                                            onError={(e) => { e.target.style.display = 'none'; }}
                                                        />
                                                        <span className={`${styles["text-xs"]} ${styles["text-blue-400"]}`}>
                                                            Открыть
                                                        </span>
                                                    </a>
                                                ) : (
                                                    <span className={`${styles["text-xs"]} ${styles["text-gray-400"]}`}>
                                                        Нет изображения
                                                    </span>
                                                )}
                                            </td>
                                            <td>
                                                {image.original_image_url ? (
                                                    <a 
                                                        href={image.original_image_url} 
                                                        target="_blank" 
                                                        rel="noopener noreferrer"
                                                        className={`${styles["text-xs"]} ${styles["text-blue-400"]}`}
                                                        style={{ 
                                                            wordBreak: 'break-all',
                                                            maxWidth: '200px',
                                                            display: 'block'
                                                        }}
                                                    >
                                                        {image.original_image_url}
                                                    </a>
                                                ) : (
                                                    <span className={`${styles["text-xs"]} ${styles["text-gray-400"]}`}>
                                                        —
                                                    </span>
                                                )}
                                            </td>
                                            <td>
                                                <span style={{
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    fontSize: '12px',
                                                    fontWeight: 'bold',
                                                    backgroundColor: 
                                                        image.download_status === 'downloaded' ? '#d4edda' :
                                                        image.download_status === 'pending' ? '#fff3cd' :
                                                        image.download_status === 'failed' ? '#f8d7da' : '#e9ecef',
                                                    color:
                                                        image.download_status === 'downloaded' ? '#155724' :
                                                        image.download_status === 'pending' ? '#856404' :
                                                        image.download_status === 'failed' ? '#721c24' : '#495057'
                                                }}>
                                                    {image.download_status === 'downloaded' ? '✅ Скачано' :
                                                     image.download_status === 'pending' ? '⏳ В очереди' :
                                                     image.download_status === 'failed' ? '❌ Ошибка' : image.download_status}
                                                </span>
                                                {image.download_error && (
                                                    <div style={{ fontSize: '11px', color: '#dc3545', marginTop: '4px' }}>
                                                        {image.download_error}
                                                    </div>
                                                )}
                                            </td>
                                            <td className={`${styles["text-xs"]}`}>
                                                {formatDate(image.created_at)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {parsedImagesPagination && (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', marginTop: '20px' }}>
                                <button 
                                    onClick={() => setParsedImagesPage(Math.max(1, parsedImagesPage - 1))}
                                    disabled={parsedImagesPage <= 1}
                                    style={{ padding: '8px 16px', borderRadius: '5px', border: '1px solid rgba(148, 163, 184, 0.2)', backgroundColor: parsedImagesPage <= 1 ? 'rgba(30, 41, 59, 0.4)' : 'rgba(30, 41, 59, 0.8)', color: '#e2e8f0' }}
                                >
                                    ← Предыдущая
                                </button>
                                
                                <span style={{ fontSize: '14px', color: '#666' }}>
                                    Страница {parsedImagesPage} из {parsedImagesPagination.totalPages}
                                </span>
                                
                                <button 
                                    onClick={() => setParsedImagesPage(parsedImagesPage + 1)}
                                    disabled={!parsedImagesPagination.hasMore}
                                    style={{ padding: '8px 16px', borderRadius: '5px', border: '1px solid rgba(148, 163, 184, 0.2)', backgroundColor: !parsedImagesPagination.hasMore ? 'rgba(30, 41, 59, 0.4)' : 'rgba(30, 41, 59, 0.8)', color: '#e2e8f0' }}
                                >
                                    Следующая →
                                </button>
                            </div>
                        )}
                    </>
                )}

                <div className={styles["info-block"]}>
                    <strong>Информация о спарсенных изображениях:</strong><br />
                    • Изображения загружаются с внешнего источника (enjoyer.vodka)<br />
                    • Статус "Скачано" означает, что изображение сохранено на сервере<br />
                    • Используйте поиск для быстрого нахождения конкретной игры<br />
                    • Синхронизация связывает спарсенные изображения с играми в основной таблице
                </div>
            </div>

            <div className={styles["prefs-section"]}>
                <h2>📈 Статистика запусков игр</h2>
                
                <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <label>
                        <strong>Период:</strong>
                        <select 
                            value={launchStatsPeriod} 
                            onChange={(e) => setLaunchStatsPeriod(e.target.value)}
                            style={{ marginLeft: '10px', padding: '5px' }}
                        >
                            <option value="7">7 дней</option>
                            <option value="30">30 дней</option>
                            <option value="90">90 дней</option>
                            <option value="365">1 год</option>
                        </select>
                    </label>
                    
                    <button 
                        onClick={fetchLaunchStats}
                        disabled={launchStatsLoading}
                        className={styles["btn-primary"]}
                    >
                        {launchStatsLoading ? '⏳ Загрузка...' : '🔄 Обновить'}
                    </button>
                </div>

                {launchStatsLoading ? (
                    <div className={`${styles["text-center"]} ${styles["p-10"]} ${styles["text-lg"]} ${styles["text-gray-400"]}`}>
                        ⏳ Загрузка статистики запусков...
                    </div>
                ) : launchStats ? (
                    <>
                        <div className={styles["stats-grid"]}>
                            <div className={`${styles["stat-card"]} ${styles["bg-blue-100"]}`}>
                                <div className={`${styles["stat-number"]} ${styles["text-blue-600"]}`}>
                                    {launchStats.totalStats.total_sessions}
                                </div>
                                <div className={styles["stat-label"]}>
                                    Всего сессий
                                </div>
                            </div>

                            <div className={`${styles["stat-card"]} ${styles["bg-green-100"]}`}>
                                <div className={`${styles["stat-number"]} ${styles["text-green-600"]}`}>
                                    {launchStats.totalStats.unique_players}
                                </div>
                                <div className={styles["stat-label"]}>
                                    Уникальных игроков
                                </div>
                            </div>

                            <div className={`${styles["stat-card"]} ${styles["bg-yellow-100"]}`}>
                                <div className={`${styles["stat-number"]} ${styles["text-yellow-600"]}`}>
                                    {launchStats.totalStats.games_played}
                                </div>
                                <div className={styles["stat-label"]}>
                                    Игр запущено
                                </div>
                            </div>

                            <div className={`${styles["stat-card"]} ${styles["bg-purple-100"]}`}>
                                <div className={`${styles["stat-number"]} ${styles["text-purple-600"]}`}>
                                    {launchStats.totalStats.house_edge}%
                                </div>
                                <div className={styles["stat-label"]}>
                                    House Edge
                                </div>
                            </div>
                        </div>

                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginTop: '20px' }}>
                            <div>
                                <h4>🏆 Топ игр по запускам:</h4>
                                <div className={styles["prefs-table-wrapper"]}>
                                    <table className={styles["prefs-table"]}>
                                        <thead>
                                            <tr>
                                                <th>Игра</th>
                                                <th>Провайдер</th>
                                                <th>Запуски</th>
                                                <th>Игроки</th>
                                                <th>RTP</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {launchStats.topGames.map((game, index) => (
                                                <tr key={game.uuid}>
                                                    <td>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                            {(game.parsed_image_path || game.local_image_path || game.image) && (
                                                                <img
                                                                    src={game.parsed_image_path ? `${API_URL}${game.parsed_image_path}` :
                                                                         game.local_image_path ? `${API_URL}${game.local_image_path}` :
                                                                         game.image}
                                                                    alt={game.name}
                                                                    style={{ width: '32px', height: '32px', borderRadius: '4px' }}
                                                                />
                                                            )}
                                                            <div>
                                                                <div style={{ fontWeight: 'bold', fontSize: '12px' }}>
                                                                    {game.name}
                                                                </div>
                                                                <div style={{ fontSize: '10px', color: '#666' }}>
                                                                    #{index + 1}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <span style={{ 
                                                            backgroundColor: '#e3f2fd', 
                                                            padding: '2px 6px', 
                                                            borderRadius: '3px',
                                                            fontSize: '11px'
                                                        }}>
                                                            {game.provider}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <strong>{game.launch_count}</strong>
                                                    </td>
                                                    <td>
                                                        {game.unique_players}
                                                    </td>
                                                    <td>
                                                        <span style={{ 
                                                            color: parseFloat(game.rtp) > 95 ? '#28bc10' : 
                                                                   parseFloat(game.rtp) > 90 ? '#ffb300' : '#ff4757',
                                                            fontWeight: 'bold'
                                                        }}>
                                                            {game.rtp}%
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div>
                                <h4>🏢 Топ провайдеров по запускам:</h4>
                                <div className={styles["prefs-table-wrapper"]}>
                                    <table className={styles["prefs-table"]}>
                                        <thead>
                                            <tr>
                                                <th>Провайдер</th>
                                                <th>Запуски</th>
                                                <th>Игроки</th>
                                                <th>Игр</th>
                                                <th>RTP</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {launchStats.topProviders.map((provider, index) => (
                                                <tr key={provider.provider}>
                                                    <td>
                                                        <div>
                                                            <div style={{ fontWeight: 'bold' }}>
                                                                {provider.provider}
                                                            </div>
                                                            <div style={{ fontSize: '10px', color: '#666' }}>
                                                                #{index + 1}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <strong>{provider.launch_count}</strong>
                                                    </td>
                                                    <td>
                                                        {provider.unique_players}
                                                    </td>
                                                    <td>
                                                        {provider.games_played}
                                                    </td>
                                                    <td>
                                                        <span style={{ 
                                                            color: parseFloat(provider.rtp) > 95 ? '#28bc10' : 
                                                                   parseFloat(provider.rtp) > 90 ? '#ffb300' : '#ff4757',
                                                            fontWeight: 'bold'
                                                        }}>
                                                            {provider.rtp}%
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <div style={{ 
                        padding: '20px', 
                        textAlign: 'center', 
                        color: '#666',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '5px'
                    }}>
                        <p>📭 Нет данных о запусках игр</p>
                        <p style={{ fontSize: '14px' }}>
                            Статистика появится после первых игровых сессий
                        </p>
                    </div>
                )}

                <div className={styles["info-block"]}>
                    <strong>Информация о статистике запусков:</strong><br />
                    • Данные обновляются в реальном времени<br />
                    • RTP (Return to Player) - процент возврата игроку<br />
                    • House Edge - преимущество казино<br />
                    • Статистика учитывает только завершенные игровые сессии
                </div>
            </div>

            <div className={styles["prefs-section"]}>
                <h2>💰 Баланс мерчанта (Slotegrator)</h2>
                
                <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <button 
                        onClick={fetchMerchantLimits}
                        disabled={merchantLimitsLoading}
                        className={styles["btn-primary"]}
                    >
                        {merchantLimitsLoading ? '⏳ Загрузка...' : '🔄 Обновить баланс'}
                    </button>
                    
                    <div style={{ fontSize: '14px', color: '#666' }}>
                        Обновлено: {merchantLimits.length > 0 ? new Date().toLocaleTimeString('ru-RU') : '—'}
                    </div>
                </div>

                {merchantLimitsLoading ? (
                    <div className={`${styles["text-center"]} ${styles["p-10"]} ${styles["text-lg"]} ${styles["text-gray-400"]}`}>
                        ⏳ Загрузка баланса мерчанта...
                    </div>
                ) : (
                    <>
                        {merchantLimits.length > 0 ? (
                            <div className={styles["prefs-table-wrapper"]}>
                                <table className={styles["prefs-table"]}>
                                    <thead>
                                        <tr>
                                            <th>Валюта</th>
                                            <th>Доступная сумма</th>
                                            <th>Провайдеры</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {merchantLimits.map((limit, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <span style={{ 
                                                        backgroundColor: '#e3f2fd', 
                                                        padding: '4px 8px', 
                                                        borderRadius: '4px',
                                                        fontSize: '14px',
                                                        fontWeight: 'bold'
                                                    }}>
                                                        {limit.currency}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#28bc10' }}>
                                                        {parseFloat(limit.amount).toLocaleString('ru-RU', { 
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2 
                                                        })} {limit.currency}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                                        {limit.providers && limit.providers.length > 0 ? (
                                                            limit.providers.map((provider, pIndex) => (
                                                                <span 
                                                                    key={pIndex}
                                                                    style={{ 
                                                                        backgroundColor: 'rgba(30, 41, 59, 0.8)', 
                                                                        padding: '2px 6px', 
                                                                        borderRadius: '3px',
                                                                        fontSize: '12px',
                                                                        border: '1px solid rgba(148, 163, 184, 0.2)',
                                                                        color: '#e2e8f0'
                                                                    }}
                                                                >
                                                                    {provider}
                                                                </span>
                                                            ))
                                                        ) : (
                                                            <span style={{ color: '#666', fontSize: '12px' }}>Все провайдеры</span>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div style={{ 
                                padding: '20px', 
                                textAlign: 'center', 
                                color: '#666',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '5px'
                            }}>
                                <p>📭 Лимиты не найдены</p>
                                <p style={{ fontSize: '14px' }}>
                                    Возможно, у мерчанта нет настроенных лимитов или произошла ошибка при загрузке
                                </p>
                            </div>
                        )}
                    </>
                )}

                <div className={styles["info-block"]}>
                    <strong>Информация о балансе мерчанта:</strong><br />
                    • Данные получаются через API метод /limits от Slotegrator<br />
                    • Показывает доступные суммы для каждой валюты<br />
                    • Указывает провайдеров игр, для которых действует лимит<br />
                    • Обновляется в реальном времени при нажатии кнопки "Обновить баланс"
                </div>
            </div>

            <div className={styles["prefs-section"]}>
                <h2>🎮 Список игр</h2>

                <div className={`${styles["flex"]} ${styles["gap-4"]} ${styles["mb-6"]} ${styles["flex-wrap"]} ${styles["items-center"]}`}>
                    <div className={styles["form-group"]}>
                        <label className={styles["form-label"]}>
                            🔍 Поиск по названию:
                        </label>
                        <input
                            type="text"
                            value={gamesSearch}
                            onChange={(e) => handleGamesSearch(e.target.value)}
                            placeholder="Введите название игры..."
                            className={`${styles["form-input"]} ${styles["w-full"]}`}
                        />
                    </div>

                    <div className={styles["form-group"]}>
                        <label className={styles["form-label"]}>
                            📂 Фильтр по провайдеру:
                        </label>
                        <select
                            value={gamesProviderFilter}
                            onChange={(e) => handleGamesProviderFilter(e.target.value)}
                            className={`${styles["form-select"]}`}
                        >
                            <option value="">Все провайдеры</option>
                            {gamesStats?.providersList.map(provider => (
                                <option key={provider.provider} value={provider.provider}>
                                    {provider.provider} ({provider.games_count})
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className={styles["form-group"]}>
                        <label className={styles["form-label"]}>
                            🧩 Фильтр по типу:
                        </label>
                        <select
                            value={gamesTypeFilter}
                            onChange={(e) => handleGamesTypeFilter(e.target.value)}
                            className={`${styles["form-select"]}`}
                        >
                            <option value="">Все типы</option>
                            {gamesTypesAvailable.map((type) => (
                                <option key={type} value={type}>
                                    {type}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className={styles["mt-6"]}>
                        <button
                            onClick={() => fetchGamesList()}
                            disabled={gamesLoading}
                            className={styles["btn-primary"]}
                        >
                            {gamesLoading ? '⏳ Загрузка...' : '🔄 Обновить'}
                        </button>
                    </div>
                </div>

                {gamesLoading ? (
                    <div className={`${styles["text-center"]} ${styles["p-10"]} ${styles["text-lg"]} ${styles["text-gray-400"]}`}>
                        ⏳ Загрузка игр...
                    </div>
                ) : (
                    <>
                        {gamesPagination && (
                            <div className={`${styles["mb-4"]} ${styles["text-sm"]} ${styles["text-gray-400"]}`}>
                                Показано {gamesList.length} из {gamesPagination.total} игр 
                                (страница {gamesPagination.page} из {gamesPagination.totalPages})
                            </div>
                        )}

                        <div className={styles["prefs-table-wrapper"]}>
                            <table className={styles["prefs-table"]}>
                                <thead>
                                    <tr>
                                        <th>UUID</th>
                                        <th>Название</th>
                                        <th>Провайдер</th>
                                        <th>Тип</th>
                                        <th>Технология</th>
                                        <th>Фриспины</th>
                                        <th>Изображения</th>
                                        <th>Ссылки</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {gamesList.map((game, index) => (
                                        <tr key={game.uuid || index}>
                                            <td className={`${styles["text-xs"]} ${styles["font-mono"]}`}>
                                                {game.uuid?.substr(0, 8) || '—'}...
                                            </td>
                                            <td className={styles["font-bold"]}>
                                                {game.name || 'Без названия'}
                                            </td>
                                            <td>
                                                <span style={{ 
                                                    backgroundColor: '#e3f2fd', 
                                                    padding: '2px 6px', 
                                                    borderRadius: '3px',
                                                    fontSize: '12px'
                                                }}>
                                                    {game.provider}
                                                </span>
                                            </td>
                                            <td>{game.type}</td>
                                            <td>{game.technology}</td>
                                            <td>
                                                {game.has_freespins ? (
                                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                                        <span style={{ 
                                                            color: '#28bc10', 
                                                            fontWeight: 'bold',
                                                            fontSize: '14px'
                                                        }}>
                                                            ✅ Да
                                                        </span>
                                                        {game.freespin_valid_until_full_day === 1 && (
                                                            <span style={{ 
                                                                color: '#4891ff', 
                                                                fontSize: '10px'
                                                            }}>
                                                                📅 Full Day
                                                            </span>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <span style={{ 
                                                        color: '#999', 
                                                        fontSize: '12px'
                                                    }}>
                                                        ❌ Нет
                                                    </span>
                                                )}
                                            </td>
                                            <td>
                                                <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                                                    {game.hasOriginalImage && (
                                                        <span className={`${styles["text-green-400"]} ${styles["text-xs"]}`}>📷 Оригинал</span>
                                                    )}
                                                    {game.hasLocalImage && (
                                                        <span className={`${styles["text-blue-400"]} ${styles["text-xs"]}`}>💾 Локальный</span>
                                                    )}
                                                    {game.hasParsedImage && (
                                                        <span style={{ color: '#ff9800', fontSize: '12px' }}>🔍 Парсенный</span>
                                                    )}
                                                    {!game.hasOriginalImage && !game.hasLocalImage && !game.hasParsedImage && (
                                                        <span style={{ color: '#f44336', fontSize: '12px' }}>❌ Нет изображений</span>
                                                    )}
                                                </div>
                                            </td>
                                            <td>
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                                                    {game.originalImage && (
                                                        <a href={game.originalImage} target="_blank" rel="noopener noreferrer" 
                                                           className={`${styles["text-xs"]} ${styles["text-blue-400"]}`}>
                                                            📷 Оригинал
                                                        </a>
                                                    )}
                                                    {game.localImage && (
                                                        <a href={`${API_URL}${game.localImage}`} target="_blank" rel="noopener noreferrer"
                                                           className={`${styles["text-xs"]} ${styles["text-green-400"]}`}>
                                                            💾 Локальный
                                                        </a>
                                                    )}
                                                    {game.parsedImage && (
                                                        <a href={`${API_URL}${game.parsedImage}`} target="_blank" rel="noopener noreferrer"
                                                           className={`${styles["text-xs"]} ${styles["text-yellow-400"]}`}>
                                                            🔍 Парсенный
                                                        </a>
                                                    )}
                                                    {!game.originalImage && !game.localImage && !game.parsedImage && (
                                                        <span className={`${styles["text-xs"]} ${styles["text-gray-400"]}`}>—</span>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {gamesPagination && (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '15px', marginTop: '20px' }}>
                                <button 
                                    onClick={() => setGamesPage(Math.max(1, gamesPage - 1))}
                                    disabled={gamesPage <= 1}
                                    style={{ padding: '8px 16px', borderRadius: '5px', border: '1px solid rgba(148, 163, 184, 0.2)', backgroundColor: gamesPage <= 1 ? 'rgba(30, 41, 59, 0.4)' : 'rgba(30, 41, 59, 0.8)', color: '#e2e8f0' }}
                                >
                                    ← Предыдущая
                                </button>
                                
                                <span style={{ fontSize: '14px', color: '#666' }}>
                                    Страница {gamesPage} из {gamesPagination.totalPages}
                                </span>
                                
                                <button 
                                    onClick={() => setGamesPage(gamesPage + 1)}
                                    disabled={!gamesPagination.hasMore}
                                    style={{ padding: '8px 16px', borderRadius: '5px', border: '1px solid rgba(148, 163, 184, 0.2)', backgroundColor: !gamesPagination.hasMore ? 'rgba(30, 41, 59, 0.4)' : 'rgba(30, 41, 59, 0.8)', color: '#e2e8f0' }}
                                >
                                    Следующая →
                                </button>
                            </div>
                        )}
                    </>
                )}

                <div style={{ marginTop: '20px', fontSize: '12px', color: '#666', backgroundColor: '#f8f9fa', padding: '10px', borderRadius: '5px' }}>
                    <strong>Информация о столбцах:</strong><br />
                    • <strong>UUID:</strong> Уникальный идентификатор игры в системе GIS<br />
                    • <strong>Название:</strong> Название игры на русском языке<br />
                    • <strong>Провайдер:</strong> Разработчик игры (Slotegrator, Novomatic и т.д.)<br />
                    • <strong>Тип:</strong> Тип игры (Slot, Live, Blackjack и т.д.)<br />
                    • <strong>Технология:</strong> Технология разработки (HTML5, Flash и т.д.)<br />
                    • <strong>Фриспины:</strong> Поддерживает ли игра начисление фриспинов. "📅 Full Day" означает, что срок действия кампании должен истекать в 00:00:00<br />
                    • <strong>Изображения:</strong> Статус наличия изображений игры<br />
                    • <strong>Ссылки:</strong> Прямые ссылки для просмотра изображений
                </div>
            </div>

            <div className={styles["prefs-section"]}>
                <h2>Управление фриспинами</h2>

                <div style={{ marginBottom: '20px' }}>
                    <h3>Управление кампаниями фриспинов</h3>
                    <input
                        type="number"
                        className={styles["prefs-input"]}
                        value={freespinUserId}
                        placeholder="ID пользователя"
                        onChange={(e) => setFreespinUserId(e.target.value)}
                        style={{ marginRight: '10px', marginBottom: '10px' }}
                    />
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                        <button
                            onClick={handleSyncCleanupFreespins}
                            disabled={freespinLoading}
                            style={{ backgroundColor: '#4891ff', color: 'white', padding: '8px 16px', borderRadius: '5px', border: 'none', cursor: freespinLoading ? 'not-allowed' : 'pointer' }}
                        >
                            🔄 Синхронизировать с GIS
                        </button>
                        <button
                            onClick={handleCancelAllFreespins}
                            disabled={freespinLoading}
                            style={{ backgroundColor: '#ff4757', color: 'white', padding: '8px 16px', borderRadius: '5px', border: 'none', cursor: freespinLoading ? 'not-allowed' : 'pointer' }}
                        >
                            🚫 Отменить ВСЕ кампании
                        </button>
                        <button
                            onClick={() => fetchFreespinCampaigns(freespinUserId)}
                            disabled={freespinLoading}
                            style={{ backgroundColor: '#28bc10', color: 'white', padding: '8px 16px', borderRadius: '5px', border: 'none', cursor: freespinLoading ? 'not-allowed' : 'pointer' }}
                        >
                            {freespinLoading ? "Загрузка..." : "📋 Показать кампании"}
                        </button>
                        <button
                            onClick={() => fetchFreespinCampaigns()}
                            disabled={freespinLoading}
                            style={{ backgroundColor: '#ffb300', color: 'white', padding: '8px 16px', borderRadius: '5px', border: 'none', cursor: freespinLoading ? 'not-allowed' : 'pointer' }}
                        >
                            📋 Все кампании
                        </button>
                    </div>
                    
                    {syncCleanupResult && (
                        <div style={{ 
                            marginTop: '15px', 
                            padding: '15px', 
                            backgroundColor: '#e8f4fd', 
                            borderRadius: '8px',
                            border: '1px solid #b3d9ff'
                        }}>
                            <h4 style={{ margin: '0 0 10px 0', color: '#4891ff' }}>📊 Результаты синхронизации:</h4>
                            <div style={{ fontSize: '14px' }}>
                                <div>✅ Проверено кампаний: <strong>{syncCleanupResult.checked}</strong></div>
                                <div>🔄 Отменено в GIS: <strong>{syncCleanupResult.cancelled_in_gis}</strong></div>
                                <div>❌ Не найдено в GIS: <strong>{syncCleanupResult.not_found_in_gis}</strong></div>
                                {syncCleanupResult.errors.length > 0 && (
                                    <div style={{ marginTop: '10px' }}>
                                        <div style={{ color: '#dc3545', fontWeight: 'bold' }}>⚠️ Ошибки ({syncCleanupResult.errors.length}):</div>
                                        {syncCleanupResult.errors.map((err, idx) => (
                                            <div key={idx} style={{ fontSize: '12px', color: '#666', marginLeft: '10px' }}>
                                                • ID {err.campaign_id}: {err.error}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>

                {freespinCampaigns.length > 0 && (
                    <div>
                        <h3>Кампании фриспинов ({freespinCampaigns.length})</h3>
                        <div className={styles["prefs-table-wrapper"]}>
                            <table className={styles["prefs-table"]}>
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Пользователь</th>
                                        <th>Игра</th>
                                        <th>Статус</th>
                                        <th>Фриспины<br />Локально</th>
                                        <th>Фриспины<br />GIS</th>
                                        <th>Синх.</th>
                                        <th>Ставка</th>
                                        <th>Создана</th>
                                        <th>Истекает</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {freespinCampaigns.map(campaign => (
                                        <tr key={campaign.id}>
                                            <td>{campaign.id}</td>
                                            <td>
                                                <strong>{campaign.user_id}</strong>
                                                <br />
                                                <span style={{ fontSize: '12px', color: '#666' }}>
                                                    {campaign.username}
                                                </span>
                                            </td>
                                            <td>
                                                {campaign.game_image && (
                                                    <img
                                                        src={campaign.game_image.startsWith('/') ?
                                                            `${API_URL}${campaign.game_image}` :
                                                            campaign.game_image
                                                        }
                                                        alt={campaign.game_name}
                                                        style={{ width: '32px', height: '32px', marginRight: '8px' }}
                                                    />
                                                )}
                                                <span style={{ fontSize: '12px' }}>
                                                    {campaign.game_name || 'Неизвестная игра'}
                                                </span>
                                            </td>
                                            <td>
                                                <span style={{
                                                    color: getStatusColor(campaign.status),
                                                    fontWeight: 'bold'
                                                }}>
                                                    {campaign.status.toUpperCase()}
                                                </span>
                                            </td>
                                            <td>
                                                <div style={{ textAlign: 'center' }}>
                                                    <div style={{ color: '#4891ff', fontWeight: 'bold' }}>
                                                        {campaign.freespins_left}/{campaign.freespins_count}
                                                    </div>
                                                    <div style={{ fontSize: '10px', color: '#666' }}>
                                                        Исп: {campaign.freespins_used || 0}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                {campaign.gis_data ? (
                                                    <div style={{ textAlign: 'center' }}>
                                                        <div style={{
                                                            color: (campaign.gis_data.status === 'Active' && !campaign.gis_data.is_canceled) ? '#28bc10' : '#ff4757',
                                                            fontWeight: 'bold'
                                                        }}>
                                                            {campaign.gis_data.quantity_left}/{campaign.gis_data.quantity}
                                                        </div>
                                                        <div style={{ fontSize: '10px', color: '#666' }}>
                                                            {campaign.gis_data.is_canceled ? `${campaign.gis_data.status} (ОТМЕНЕНА)` : campaign.gis_data.status}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <span style={{ color: '#ff4757', fontSize: '12px' }}>
                                                        {campaign.gis_sync_error || 'Нет данных'}
                                                    </span>
                                                )}
                                            </td>
                                            <td>
                                                {(() => {
                                                    const syncInfo = getSyncStatusInfo(campaign);
                                                    return (
                                                        <div
                                                            style={{
                                                                cursor: 'help',
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'center'
                                                            }}
                                                            title={`${syncInfo.title}\n${syncInfo.details}`}
                                                        >
                                                            <span style={{
                                                                color: syncInfo.color,
                                                                fontSize: '16px'
                                                            }}>
                                                                {syncInfo.icon}
                                                            </span>
                                                            {!campaign.data_match && campaign.detailed_comparison && (
                                                                <button
                                                                    style={{
                                                                        fontSize: '10px',
                                                                        padding: '2px 4px',
                                                                        marginTop: '2px',
                                                                        border: '1px solid rgba(148, 163, 184, 0.2)',
                                                                        backgroundColor: 'rgba(30, 41, 59, 0.8)',
                                                                        color: '#e2e8f0',
                                                                        borderRadius: '3px',
                                                                        cursor: 'pointer'
                                                                    }}
                                                                    onClick={() => {
                                                                        const comp = campaign.detailed_comparison.comparison;
                                                                        const local = campaign.detailed_comparison.local;
                                                                        const gis = campaign.detailed_comparison.gis;

                                                                        let details = `Кампания ID: ${campaign.id}\nGIS ID: ${campaign.gis_freespin_id}\n\n`;
                                                                        details += `ЛОКАЛЬНЫЕ ДАННЫЕ:\n`;
                                                                        details += `- Общее кол-во: ${local.quantity}\n`;
                                                                        details += `- Осталось: ${local.quantity_left}\n`;
                                                                        details += `- Использовано: ${local.quantity_used}\n`;
                                                                        details += `- Статус: ${local.status}\n`;
                                                                        details += `- Ставка: ${local.bet_amount}\n`;
                                                                        details += `- Валюта: ${local.currency}\n\n`;

                                                                        details += `GIS ДАННЫЕ:\n`;
                                                                        details += `- Общее кол-во: ${gis.quantity}\n`;
                                                                        details += `- Осталось: ${gis.quantity_left}\n`;
                                                                        details += `- Использовано: ${gis.quantity_used}\n`;
                                                                        details += `- Статус: ${gis.status}\n`;
                                                                        details += `- Отменена: ${gis.is_canceled ? 'ДА' : 'НЕТ'}\n`;
                                                                        details += `- Эффективный статус: ${gis.effective_status}\n`;
                                                                        details += `- Ставка: ${gis.bet_amount}\n`;
                                                                        if (gis.bet_amount_raw !== gis.bet_amount) {
                                                                            details += `- Ставка (raw): ${gis.bet_amount_raw}\n`;
                                                                            details += `- Denomination: ${gis.denomination}\n`;
                                                                        }
                                                                        details += `- Валюта: ${gis.currency}\n\n`;

                                                                        details += `НЕСООТВЕТСТВИЯ:\n`;
                                                                        Object.entries(comp).forEach(([key, matches]) => {
                                                                            if (!matches) {
                                                                                const fieldName = key.replace('_match', '').replace('_', ' ');

                                                                                // Особая обработка для bet_amount если он был пропущен
                                                                                if (key === 'bet_amount_match' && gis.bet_amount_skipped) {
                                                                                    details += `ℹ️ ${fieldName} (сравнение пропущено - в GIS только denomination)\n`;
                                                                                } else {
                                                                                    details += `❌ ${fieldName}\n`;
                                                                                }
                                                                            }
                                                                        });

                                                                        alert(details);
                                                                    }}
                                                                >
                                                                    Детали
                                                                </button>
                                                            )}
                                                        </div>
                                                    );
                                                })()}
                                            </td>
                                            <td>
                                                {campaign.bet_amount} {campaign.currency}
                                            </td>
                                            <td style={{ fontSize: '12px' }}>
                                                {formatDate(campaign.created_at)}
                                            </td>
                                            <td style={{ fontSize: '12px' }}>
                                                {formatDate(campaign.expires_at)}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                            <strong>Легенда синхронизации:</strong>
                            <span style={{ color: '#28bc10' }}> ✅ Синхронизировано</span> |
                            <span style={{ color: '#ffb300' }}> ⚠️ Данные не совпадают</span> |
                            <span style={{ color: '#ff4757' }}> ❌ Ошибка синхронизации</span>
                        </div>
                    </div>
                )}
            </div>

            <div className={styles["prefs-section"]}>
                <h2>Тестовое автоначисление кешбека</h2>
                <button onClick={handleTestAutoCashback} disabled={testCashbackLoading}>
                    {testCashbackLoading ? "Загрузка..." : "Запустить автоначисление"}
                </button>
                {testCashbackResult && (
                    <div style={{ marginTop: 10, color: testCashbackResult.success ? 'green' : 'red' }}>
                        {testCashbackResult.message}
                        {testCashbackResult.processedUsers !== undefined && ` (Обработано пользователей: ${testCashbackResult.processedUsers})`}
                        {testCashbackResult.totalCashback !== undefined && ` (Общая сумма кешбека: ${testCashbackResult.totalCashback} ₽)`}
                    </div>
                )}
            </div>

            <div className={styles["prefs-section"]}>
                <h2>Самовалидация GIS интегратора</h2>
                <p style={{ fontSize: '14px', color: '#666', marginBottom: '10px' }}>
                    Проверка корректности реализации интеграции с игровым агрегатором.
                    Требуется активная игровая сессия (не старше 15 минут).
                </p>
                <button onClick={handleGisValidation} disabled={gisValidationLoading}>
                    {gisValidationLoading ? "Выполнение валидации..." : "🔍 Запустить валидацию"}
                </button>
                {gisValidationResult && (
                    <div style={{ marginTop: 15 }}>
                        <div style={{
                            color: gisValidationResult.success && gisValidationResult.validationPassed ? 'green' : 'red',
                            fontWeight: 'bold',
                            marginBottom: '10px'
                        }}>
                            {gisValidationResult.message}
                        </div>

                        {gisValidationResult.log && gisValidationResult.log.length > 0 && (
                            <div>
                                <h4>Лог валидации:</h4>
                                <div style={{
                                    backgroundColor: 'rgb(40 40 40)',
                                    padding: '10px',
                                    borderRadius: '5px',
                                    maxHeight: '300px',
                                    overflowY: 'auto',
                                    fontFamily: 'monospace',
                                    fontSize: '12px'
                                }}>
                                    {gisValidationResult.log.map((logEntry, index) => (
                                        <div key={index} style={{ marginBottom: '5px' }}>
                                            {logEntry}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {gisValidationResult.error && (
                            <div style={{
                                backgroundColor: '#ffe6e6',
                                padding: '10px',
                                borderRadius: '5px',
                                marginTop: '10px'
                            }}>
                                <strong>Детали ошибки:</strong>
                                <pre style={{ fontSize: '12px', marginTop: '5px', whiteSpace: 'pre-wrap' }}>
                                    {typeof gisValidationResult.error === 'object'
                                        ? JSON.stringify(gisValidationResult.error, null, 2)
                                        : gisValidationResult.error
                                    }
                                </pre>
                            </div>
                        )}
                    </div>
                )}
            </div>


            {/* Секция управления бэкапами */}
            <div className={styles["prefs-section"]}>
                <h2>💾 Управление бэкапами базы данных</h2>
                
                <div style={{ marginBottom: '20px', padding: '15px', borderRadius: '5px' }}>
                    <h3>📋 Информация о бэкапах</h3>
                    <p style={{ margin: '5px 0', fontSize: '14px' }}>
                        <strong>Автоматические бэкапы:</strong> Создаются ежедневно в 3:00 UTC
                    </p>
                    <p style={{ margin: '5px 0', fontSize: '14px' }}>
                        <strong>Хранение:</strong> На удаленном VPS (сохраняются последние 30 дней)
                    </p>
                    <p style={{ margin: '5px 0', fontSize: '14px' }}>
                        <strong>Формат:</strong> Docker volume архивы (.tar.gz)
                    </p>
                    <p style={{ margin: '5px 0', fontSize: '14px' }}>
                        <strong>Состав:</strong> База данных (PostgreSQL) + Верификационные фото
                    </p>
                    {backupFolder && (
                        <p style={{ margin: '5px 0', fontSize: '14px' }}>
                            <strong>Папка на VPS:</strong> <code style={{ backgroundColor: '#e9ecef', padding: '2px 6px', borderRadius: '3px' }}>{backupFolder}</code>
                        </p>
                    )}
                </div>

                <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap' }}>
                    <button 
                        onClick={handleCreateBackup} 
                        disabled={backupLoading}
                        style={{ backgroundColor: '#28bc10', color: 'white', padding: '10px 20px' }}
                    >
                        {backupLoading ? "⏳ Создание..." : "💾 Создать бэкап"}
                    </button>
                    
                    <button 
                        onClick={fetchBackups}
                        disabled={backupLoading}
                        style={{ backgroundColor: '#4891ff', color: 'white', padding: '10px 20px' }}
                    >
                        🔄 Обновить список
                    </button>
                </div>

                {backupResult && (
                    <div style={{ 
                        marginBottom: '20px', 
                        padding: '15px', 
                        borderRadius: '5px',
                        backgroundColor: backupResult.success ? '#d4edda' : '#f8d7da',
                        border: `1px solid ${backupResult.success ? '#c3e6cb' : '#f5c6cb'}`,
                        color: backupResult.success ? '#155724' : '#721c24'
                    }}>
                        <strong>{backupResult.success ? '✅ Успешно:' : '❌ Ошибка:'}</strong> {backupResult.message}
                        {backupResult.dbFileName && (
                            <div style={{ marginTop: '5px', fontSize: '14px' }}>
                                <strong>БД:</strong> {backupResult.dbFileName} 
                                {backupResult.dbSize && <span> ({backupResult.dbSize} MB)</span>}
                            </div>
                        )}
                        {backupResult.verificationsFileName && (
                            <div style={{ fontSize: '14px' }}>
                                <strong>Верификации:</strong> {backupResult.verificationsFileName}
                                {backupResult.verificationsSize && <span> ({backupResult.verificationsSize} MB)</span>}
                            </div>
                        )}
                        {backupResult.totalSize && (
                            <div style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                <strong>Всего:</strong> {backupResult.totalSize} MB
                            </div>
                        )}
                        {backupResult.timestamp && (
                            <div style={{ fontSize: '14px' }}>
                                <strong>Время:</strong> {formatDate(backupResult.timestamp)}
                            </div>
                        )}
                    </div>
                )}

                <div style={{ marginBottom: '20px', padding: '15px', borderRadius: '5px', backgroundColor: '#fff3cd', border: '1px solid #ffc107' }}>
                    <h3 style={{ color: '#856404', marginTop: 0 }}>⚠️ Восстановление из бэкапа</h3>
                    <p style={{ fontSize: '14px', color: '#856404', margin: '10px 0' }}>
                        Автоматическое восстановление отключено (требуется перезапуск контейнеров).
                    </p>
                    <p style={{ fontSize: '14px', color: '#856404', margin: '10px 0' }}>
                        <strong>Для ручного восстановления:</strong>
                    </p>
                    <ol style={{ fontSize: '13px', color: '#856404', marginLeft: '20px' }}>
                        <li>Скачайте бэкап с VPS: <code style={{ backgroundColor: '#fff', padding: '2px 6px', borderRadius: '3px' }}>scp user@vps:/backups/domainname/casino_*.tar.gz /tmp/</code></li>
                        <li>Остановите контейнеры: <code style={{ backgroundColor: '#fff', padding: '2px 6px', borderRadius: '3px' }}>cd /var/www/casino && docker-compose down</code></li>
                        <li>Восстановите volumes командами из документации ниже</li>
                        <li>Запустите контейнеры: <code style={{ backgroundColor: '#fff', padding: '2px 6px', borderRadius: '3px' }}>docker-compose up -d</code></li>
                    </ol>
                    <p style={{ fontSize: '12px', color: '#856404', marginTop: '10px' }}>
                        📖 Подробная инструкция находится в файле RESTORE_BACKUP.md в корне проекта
                    </p>
                </div>

                <div>
                    <h3>📁 Доступные бэкапы ({backups.length})</h3>
                    {backups.length > 0 ? (
                        <div className={styles["prefs-table-wrapper"]}>
                            <table className={styles["prefs-table"]}>
                                <thead>
                                    <tr>
                                        <th>Дата</th>
                                        <th>База данных</th>
                                        <th>Верификации</th>
                                        <th>Общий размер</th>
                                        <th>Создан</th>
                                        <th>Статус</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {backups.map((backup) => (
                                        <tr key={backup.date} style={{ opacity: backup.complete ? 1 : 0.6 }}>
                                            <td style={{ fontFamily: 'monospace', fontWeight: 'bold' }}>
                                                {backup.date}
                                            </td>
                                            <td>
                                                {backup.dbFile ? (
                                                    <>
                                                        <div className={`${styles["text-xs"]} ${styles["text-gray-400"]}`}>{backup.dbFile}</div>
                                                        <strong>{backup.dbSize} MB</strong>
                                                    </>
                                                ) : (
                                                    <span style={{ color: '#ff4757' }}>❌ Отсутствует</span>
                                                )}
                                            </td>
                                            <td>
                                                {backup.verificationsFile ? (
                                                    <>
                                                        <div className={`${styles["text-xs"]} ${styles["text-gray-400"]}`}>{backup.verificationsFile}</div>
                                                        <strong>{backup.verificationsSize} MB</strong>
                                                    </>
                                                ) : (
                                                    <span style={{ color: '#ff4757' }}>❌ Отсутствует</span>
                                                )}
                                            </td>
                                            <td>
                                                <strong style={{ fontSize: '14px' }}>{backup.totalSize} MB</strong>
                                            </td>
                                            <td>
                                                {formatDate(backup.timestamp)}
                                            </td>
                                            <td>
                                                {backup.complete ? (
                                                    <span style={{ 
                                                        color: '#28bc10', 
                                                        fontWeight: 'bold',
                                                        fontSize: '12px'
                                                    }}>
                                                        ✅ Готов к восстановлению
                                                    </span>
                                                ) : (
                                                    <span style={{ 
                                                        color: '#ffb300', 
                                                        fontWeight: 'bold',
                                                        fontSize: '12px'
                                                    }}>
                                                        ⚠️ Неполный
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div style={{ 
                            padding: '20px', 
                            textAlign: 'center', 
                            color: '#666',
                            backgroundColor: '#f8f9fa',
                            borderRadius: '5px'
                        }}>
                            <p>📭 Бэкапы не найдены</p>
                            <p style={{ fontSize: '14px' }}>
                                Автоматические бэкапы создаются ежедневно в 3:00 UTC и сохраняются 30 дней
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Prefs2;
